var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative"}},[_c('MapComponent',{attrs:{"context":_vm.context,"can-draw":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }